import React from 'react';
import { IconProps } from '../types/types';

const AMD: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" role="img" {...props}><path fill="url(#paint0_linear)" d="M0 0h18v18H0z"/><path d="M11 7H7L4.083 4H14v9.916L11 11V7zM7 11V7.27l-3 2.804V14h3.925l2.804-3H7z" fill="#fff"/><defs><linearGradient id="paint0_linear" x1="3.349" y1="3.122" x2="21.904" y2="24.434" gradientUnits="userSpaceOnUse"><stop stopColor="#1A1E21"/><stop offset="1" stopColor="#06060A"/></linearGradient></defs></svg>
);

export default AMD;